import React from 'react';

import Container from './Container';
import { TabContentProvider } from './Context';

const TemplateComponent = () => {
  return (
    <TabContentProvider>
      <Container />
    </TabContentProvider>
  );
};

export default TemplateComponent;
